import { useState, useEffect } from "react";
import Messages_es from "../translations/Messages_es.json";
import Messages_en from "../translations/Messages_en.json";
import Messages_pt from "../translations/Messages_pt.json";

export default function Locales (dataLanguage, idPais) { 

    let initMessages = {};
    switch (dataLanguage) {
      case 'en':          
        initMessages = Messages_en;
        break;
      case 'pt':          
        initMessages = Messages_pt;
        break;
      case 'pt_BR':          
        initMessages = Messages_pt;
        break;
      default:          
        initMessages = Messages_es;
        break;
    }
    const [language, setLanguage] = useState(dataLanguage);
    const [messages, setMessages] = useState(initMessages);
    const [ms, setMs] = useState(null);

    useEffect(()=>{
      
      if (ms ===null && idPais){
        importLanguageCompany(language, idPais, setMs);
      }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[idPais]);

    useEffect(()=>{
      let finallyMessages = {};
      if(dataLanguage !== language){
        setLanguage(dataLanguage);
      }
      
      switch (language) {
        case 'en':          
          finallyMessages = Messages_en;
          break;
        case 'pt':          
          finallyMessages = Messages_pt;
          break;
        case 'pt_BR':          
          finallyMessages = Messages_pt;
          break;
        default:          
          finallyMessages = Messages_es;
          break;
      }

      if (ms) {
          const mergedMessages = mergeObjects(finallyMessages, ms);
          setMessages(mergedMessages);
      }
      
    },[dataLanguage, language, ms]);

    return {messages, language};
}

export function getLocalesProvider(locale){

  switch (locale) {
    case "pt_BR":
      return "pt";  
    default:
      return locale;
  }

}

export function mergeObjects(obj1, obj2) {
  const merged = { ...obj1 };

  for (const key in obj2) {
      if (obj2.hasOwnProperty(key)) {
          if (typeof obj2[key] === 'object' && !Array.isArray(obj2[key])) {
              merged[key] = mergeObjects(obj1[key], obj2[key]);
          } else {
              merged[key] = obj2[key];
          }
      }
  }

  return merged;
}

export async function importLanguageCompany( language, idPais, setMs ) {
  
  try{
    let pais = "";
    switch (idPais) {
      case 8:
        pais = "chl";  
        break;
      default:
        pais = "";
        break;
    }

    const path = `./Messages_${getLocalesProvider(language)}_${pais}.json`;
    const fileJson = require.context('./company/',true,/\.(json)$/);    
    const messagesCompany = fileJson(path);

    setMs(messagesCompany);

  }catch (e){
    console.log(e);
    setMs({});
  }
}